import API from '@/API/API'

const AccountSessionUtils = {
    api: API,
    state: {
        session: ''
    },
    getUserId: function (success, error) {
        this.api
            .getUserId(this.state.session)
            .then(function (res) {
                if (res.data) {
                    let data = res.data
                    if (data.error) {
                        error(data.error)
                    } else {
                        success(data);
                    }
                } else {
                    error("Failed to get user!");
                }
            })
            .catch(e => {
                error('An Error Occurred')
            })
    },
    getSession: function () {
        return localStorage.ECDsessionid
    },
    authorize: function (validClosure, goLoginClosure) {
        this.state.session = this.getSession()
        if(!this.state.session){
            goLoginClosure("")
        }
        this.getUserId((data) => {
            validClosure(data.userId);
        }, (err) => {
            goLoginClosure(err);
        })
    }

}

export default AccountSessionUtils



// WEBPACK FOOTER //
// ./src/components/account/AccountSessionUtils.js